import {FormsySchema, SignupSchemaKeys} from '.';

const getSignupSchema = (getMessage, messages): FormsySchema<SignupSchemaKeys> => ({
    guardianFirstName: {
        identifier: 'guardianFirstName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.signup.guardian.first.name')
        }
    },
    guardianLastName: {
        identifier: 'guardianLastName',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.signup.guardian.last.name')
        }
    },
    guardianRelationship: {
        identifier: 'guardianRelationship',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.signup.guardian.relationship')
        }
    },
    language: {
        identifier: 'language',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.language')
        }
    },
    phone: {
        identifier: 'phoneNumber',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.social.phone_number')
        }
    },
    url: {
        identifier: 'url',
        validations: {
            maxLength: 500
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [500])
        }
    },
    codeSelfService: {
        identifier: 'creatorCode',
        validations: {
            minLength: 3,
            maxLength: 16,
            isSpecialAlphaNumeric: true,
            noSameCharOnly: true,
            noDigitsOnly: true,
            noConsecutiveSpecialChar: true,
            noStartEndWithSpecialChar: true
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            minLength: getMessage(messages, 'errors.com.epicgames.validation.min_length', [3]),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [16]),
            isSpecialAlphaNumeric: getMessage(
                messages,
                'errors.com.epicgames.validation.alphanumeric'
            ),
            noSameCharOnly: getMessage(messages, 'errors.com.epicgames.validation.noRepeat'),
            noDigitsOnly: getMessage(messages, 'errors.com.epicgames.validation.noNumsOnly'),
            noConsecutiveSpecialChar: getMessage(
                messages,
                'errors.com.epicgames.validation.noRepeatSpecialChar'
            ),
            noStartEndWithSpecialChar: getMessage(
                messages,
                'errors.com.epicgames.validation.noStartEndSpecialChar'
            )
        },
        display: {
            text: getMessage(messages, 'epic.affiliate.ccss.desiredCode')
        }
    },
    city: {
        identifier: 'city',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.city')
        }
    },
    country: {
        identifier: 'country',
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.Country')
        }
    },
    region: {
        identifier: 'state',
        validations: {
            maxLength: 32
        },
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            ),
            maxLength: getMessage(messages, 'errors.com.epicgames.validation.max_length', [32])
        },
        display: {
            text: getMessage(messages, 'ui.profile.address.form.region'),
            textState: getMessage(messages, 'ui.profile.address.form.state')
        }
    },
    state: {
        identifier: 'state',
        validationMessages: {
            isDefaultRequiredValue: getMessage(
                messages,
                'errors.com.epicgames.validation.required_field.v2'
            )
        },
        display: {
            text: getMessage(messages, 'label.affiliate.form.tax.state')
        }
    }
});

export default getSignupSchema;
